import { Type } from 'class-transformer';

import { DataCollectionMilestone } from './data-collection-milestone.model';

export class SiteMilestonesSummary {
    @Type(() => DataCollectionMilestone)
    public milestones: DataCollectionMilestone[] = [];

    public canScheduleEvents: boolean = false;
}
